import { normalizarData, normalizarValor } from '../../utils/index';
import * as XLSX from 'xlsx';

const superNormalize = (h) => {
    return String(h || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
};

const superNormalizeNoSpace = (h) => {
    return superNormalize(h).replace(/[^a-z0-9]/g, '');
};

export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalizeNoSpace);
        
        if (
            cleanRow.includes('id') && 
            cleanRow.includes('nsu') &&
            cleanRow.includes('datadecaptura') &&
            cleanRow.includes('snequipamento')
        ) {
            return true;
        }
    }
    return false;
};

const addOneDay = (dateStr) => {
    if (!dateStr) return null;
    
    let y, m, d;
    if (dateStr.includes('/')) {
        [d, m, y] = dateStr.split('/');
    } else if (dateStr.includes('-')) {
        [y, m, d] = dateStr.split('-');
    } else {
        return dateStr;
    }

    const dateObj = new Date(Number(y), Number(m) - 1, Number(d), 12, 0, 0); 
    
    dateObj.setDate(dateObj.getDate() + 1); 

    const ny = dateObj.getFullYear();
    const nm = String(dateObj.getMonth() + 1).padStart(2, '0');
    const nd = String(dateObj.getDate()).padStart(2, '0');
    
    return `${ny}-${nm}-${nd}`;
};

export const processar = (dadosArray) => {
    let idxCabecalho = -1;
    let colMap = {};

    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;

        const cleanRow = linha.map(superNormalizeNoSpace);
        
        if (cleanRow.includes('datadecaptura') && cleanRow.includes('snequipamento')) {
            idxCabecalho = i;
            cleanRow.forEach((h, idx) => {
                if (h) colMap[h] = idx;
            });
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Repasses Cappta não encontrado.');
    }

    const repasses = [];
    
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        const idxStatus = colMap['status'];
        if (idxStatus !== undefined) {
            const status = String(linha[idxStatus] || '').toLowerCase().trim();
            if (status !== 'sucesso') {
                continue; // Pular recusadas, canceladas
            }
        }

        const idxData = colMap['datadecaptura'];
        const dataStrRaw = String(linha[idxData] || '').trim();
        if (!dataStrRaw) continue;
        
        const dataStr = dataStrRaw.split(' ')[0];
        const dataNormalizada = normalizarData(dataStr); 
        if (!dataNormalizada) continue;

        const dataPagamento = addOneDay(dataNormalizada);

        const idxValorLiquido = colMap['valorliquido'];
        const idxValor = colMap['valor'];
        
        let valorRaw = linha[idxValorLiquido];
        if (valorRaw === undefined || valorRaw === null || valorRaw === '') {
            valorRaw = linha[idxValor]; // Fallback
        }
        
        const valor = normalizarValor(valorRaw);

        // Opção 1: Hardcoded "Cappta" para agrupar corretamente
        const tipoStr = 'Cappta';

        if (dataPagamento && valor !== null && valor !== 0) {
            repasses.push({
                linha: i + 1,
                data: dataPagamento,
                valor: valor,
                dataOriginal: dataStr,
                tipo: tipoStr
            });
        }
    }

    return repasses;
};
